import React, { useEffect, useRef } from 'react';
export function MatrixRain() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    let width = window.innerWidth;
    let height = window.innerHeight;
    // Set canvas size
    const resize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    window.addEventListener('resize', resize);
    resize();
    // Configuration
    const fontSize = 14;
    const columns = Math.ceil(width / fontSize);
    // State for each column
    // drops[i] = y position of the drop
    const drops: number[] = [];
    // speeds[i] = speed multiplier for that column (for depth effect)
    const speeds: number[] = [];
    // opacities[i] = base opacity for that column
    const opacities: number[] = [];
    // chars[i] = current character for that column (to reduce flickering)
    const currentChars: string[] = [];
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789$@#%&<>[]{}';
    // Initialize columns
    for (let i = 0; i < columns; i++) {
      drops[i] = Math.random() * -100; // Start above screen randomly
      speeds[i] = Math.random() * 0.15 + 0.1; // Speed between 0.1 and 0.25 (much slower)
      opacities[i] = Math.random() * 0.5 + 0.1; // Opacity between 0.1 and 0.6
      currentChars[i] = characters.charAt(Math.floor(Math.random() * characters.length));
    }
    let frameCount = 0;
    const draw = () => {
      // Create fade effect
      // Use a very transparent black to make trails longer
      ctx.fillStyle = 'rgba(5, 5, 5, 0.08)';
      ctx.fillRect(0, 0, width, height);
      ctx.font = `${fontSize}px "Share Tech Mono", monospace`;
      // Draw drops
      for (let i = 0; i < drops.length; i++) {
        // Randomly change character occasionally
        if (Math.random() > 0.95) {
          currentChars[i] = characters.charAt(Math.floor(Math.random() * characters.length));
        }
        const text = currentChars[i];
        const x = i * fontSize;
        const y = drops[i] * fontSize;
        // Color logic
        // Occasional bright white/green character for "glitch" or "lead" effect
        const isBright = Math.random() > 0.98;
        if (isBright) {
          ctx.fillStyle = '#fff'; // White tip
          ctx.shadowBlur = 8;
          ctx.shadowColor = '#00ff41';
        } else {
          ctx.fillStyle = `rgba(0, 255, 65, ${opacities[i]})`; // Standard matrix green with column opacity
          ctx.shadowBlur = 0;
        }
        ctx.fillText(text, x, y);
        // Reset drop to top randomly or when it goes off screen
        if (y > height && Math.random() > 0.975) {
          drops[i] = 0;
          // Randomize properties for next run
          speeds[i] = Math.random() * 0.15 + 0.1;
          opacities[i] = Math.random() * 0.5 + 0.1;
        }
        // Move drop
        drops[i] += speeds[i];
      }
      // Optional: Horizontal scanline effect
      frameCount++;
      const scanlineY = frameCount * 0.5 % height;
      ctx.fillStyle = 'rgba(0, 255, 65, 0.03)';
      ctx.fillRect(0, scanlineY, width, 4); // Moving scanline
      requestAnimationFrame(draw);
    };
    const animationId = requestAnimationFrame(draw);
    return () => {
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationId);
    };
  }, []);
  return <>
      <canvas ref={canvasRef} className="fixed top-0 left-0 w-full h-full pointer-events-none z-0" style={{
      opacity: 0.6
    }} // Global opacity for the background layer
    data-id="element-128" />
      {/* Vignette overlay for more depth */}
      <div className="fixed inset-0 pointer-events-none z-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(5,5,5,0.8)_100%)]" data-id="element-129" />
    </>;
}